import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	StarterDashboardContactDmConfigQuery,
	StarterDashboardContactDmConfigQueryVariables,
} from './getStarterContactDmConfig.graphql';
import { StarterDashboardContactDmConfig } from './getStarterContactDmConfig.graphql';

export async function getStarterContactDmConfig(utilityContext: UtilityContext) {
	const {
		data: {
			featureConfigs: { starterDashboardContactDm },
		},
	} = await utilityContext.gql.fetch<
		StarterDashboardContactDmConfigQuery,
		StarterDashboardContactDmConfigQueryVariables
	>({
		query: StarterDashboardContactDmConfig,
		rejectOnError: true,
	});

	return {
		emailEnabled: !!starterDashboardContactDm?.emailEnabled,
	};
}
